import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface MarketplaceMetrics {
  totalKBs: number;
  totalSolutions: number;
  totalValueLocked: number;
  totalRewards: number;
}

export const useMarketplaceMetrics = () => {
  return useQuery({
    queryKey: ['marketplace-metrics'],
    queryFn: async () => {
      // Get all published KBs (platform-wide)
      const { count: totalKBs } = await supabase
        .from('knowledge_bases')
        .select('*', { count: 'exact', head: true })
        .eq('status', 'published')
        .is('deleted_at', null);

      // Get all published Solutions (platform-wide)
      const { count: totalSolutions } = await supabase
        .from('solutions')
        .select('*', { count: 'exact', head: true })
        .eq('status', 'published');

      // Calculate Total Value Locked (sum of bounty amounts)
      const { data: bounties } = await supabase
        .from('solutions')
        .select('bounty_amount')
        .eq('is_bounty', true)
        .eq('status', 'published');

      const totalValueLocked = bounties?.reduce((sum, b) => sum + (b.bounty_amount || 0), 0) || 0;

      // Calculate Total Rewards (sum of all solution prices)
      const { data: solutions } = await supabase
        .from('solutions')
        .select('price')
        .eq('status', 'published');

      const totalRewards = solutions?.reduce((sum, s) => sum + (s.price || 0), 0) || 0;

      return {
        totalKBs: totalKBs || 0,
        totalSolutions: totalSolutions || 0,
        totalValueLocked,
        totalRewards
      };
    },
    refetchInterval: 30000 // Refresh every 30 seconds
  });
};
